﻿export class SystemError {
}